/* aaa-call-us-prompt.js
 *
 * Toggles the "Open" / "Closed" state of the call-us prompt block
 * based on the current time in the configured timezone (Europe/Dublin
 * by default). Reads config from data attributes on the
 * <aaa-call-us-prompt> custom element.
 *
 * Server renders the "open" state by default; this script hides it
 * and reveals the "closed" state when outside business hours. If no
 * closed state exists in the markup, the whole block hides outside
 * hours instead.
 *
 * Re-checks every 5 minutes so a tab left open across the close-of-
 * business boundary updates without a reload.
 *
 * Bank holidays are NOT respected. Out of scope per Equijump.
 *
 * --- Chat trigger ---
 * Also wires a single document-level click handler for the [chat]
 * placeholder. Any element with [data-aaa-chat-trigger] (rendered by
 * the block's [chat] substitution) will, on click, attempt to open
 * Shopify Inbox. Stores using a different chat platform should
 * override the openChatWidget function below.
 */
(function () {
  // ---- Chat trigger (document-level delegation, runs once) ----
  // Wired before the customElements early-return so it still installs
  // even if the script tag appears multiple times on a page (one per
  // block drop).
  if (!window.__aaaChatTriggerWired) {
    window.__aaaChatTriggerWired = true;
    document.addEventListener('click', function (e) {
      var trigger = e.target && e.target.closest && e.target.closest('[data-aaa-chat-trigger]');
      if (!trigger) return;
      e.preventDefault();
      openChatWidget();
    });
  }

  function openChatWidget() {
    // Default: Shopify Inbox. Find the <shopify-chat id="ShopifyChat">
    // custom element, mark it open, then click the inner button inside
    // its shadow root to actually expand the panel. Fails silently if
    // Inbox isn't installed or Shopify changes the markup.
    try {
      var chatElement = document.getElementById('ShopifyChat');
      if (chatElement) {
        chatElement.setAttribute('is-open', 'true');
        var sr = chatElement.shadowRoot;
        var chatButton = sr && sr.querySelector('button');
        if (chatButton) chatButton.click();
        return;
      }
    } catch {
      /* fall through to the no-chat fallback below */
    }

    // No chat widget on the page (e.g. theme preview, or Inbox not
    // installed). Fall back to the contact form if one exists on this
    // page. No-op on pages without a #form target (most product pages).
    var formTarget = document.getElementById('form');
    if (formTarget && formTarget.scrollIntoView) {
      formTarget.scrollIntoView({ behavior: 'smooth' });
    }
  }

  if (customElements.get('aaa-call-us-prompt')) return;

  var DAY_MAP = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 };

  function parseList(str, fallback) {
    if (!str) return fallback;
    return str.split(',').map(function (s) { return parseInt(s.trim(), 10); }).filter(function (n) { return !isNaN(n); });
  }

  function getNow(timezone) {
    try {
      var fmt = new Intl.DateTimeFormat('en-GB', {
        timeZone: timezone || 'Europe/Dublin',
        hour: 'numeric',
        hour12: false,
        weekday: 'short'
      });
      var parts = fmt.formatToParts(new Date());
      var hourPart = parts.find(function (p) { return p.type === 'hour'; });
      var dayPart = parts.find(function (p) { return p.type === 'weekday'; });
      var hour = hourPart ? parseInt(hourPart.value, 10) : new Date().getHours();
      var dayKey = dayPart ? dayPart.value : null;
      var day = dayKey && DAY_MAP[dayKey] ? DAY_MAP[dayKey] : ((new Date().getDay() + 6) % 7) + 1;
      return { hour: hour, day: day };
    } catch {
      // Browser without Intl support / unknown timezone, fall back
      // to local time, which is fine for most Irish visitors anyway.
      var d = new Date();
      return { hour: d.getHours(), day: ((d.getDay() + 6) % 7) + 1 };
    }
  }

  class AaaCallUsPrompt extends HTMLElement {
    connectedCallback() {
      this._update();
      // Re-check every 5 minutes — handles tabs left open across the
      // open/close boundary.
      this._interval = setInterval(this._update.bind(this), 5 * 60 * 1000);
    }

    disconnectedCallback() {
      clearInterval(this._interval);
    }

    _update() {
      var tz = this.dataset.timezone || 'Europe/Dublin';
      var openDays = parseList(this.dataset.openDays, [1, 2, 3, 4, 5]);
      var openHour = parseInt(this.dataset.openHour || '8', 10);
      var closeHour = parseInt(this.dataset.closeHour || '16', 10);
      var hasClosedMessage = this.dataset.hasClosedMessage === 'true';

      var now = getNow(tz);
      var isOpen = openDays.indexOf(now.day) !== -1 && now.hour >= openHour && now.hour < closeHour;

      var openEl = this.querySelector('[data-state="open"]');
      var closedEl = this.querySelector('[data-state="closed"]');

      if (isOpen) {
        if (openEl) openEl.hidden = false;
        if (closedEl) closedEl.hidden = true;
        this.hidden = false;
      } else {
        if (openEl) openEl.hidden = true;
        if (closedEl) closedEl.hidden = false;
        // No closed message? Hide whole block when outside hours.
        this.hidden = !hasClosedMessage;
      }
    }
  }

  customElements.define('aaa-call-us-prompt', AaaCallUsPrompt);
})();
